import React from 'react';
import { Bar, Line } from 'react-chartjs-2';
import { convert } from 'src/lib/time';

export const DatesGraph = ({ dates, onClick }) => {
  const data = Object.values(dates).map((seconds) =>
    convert(seconds, 'hours').toFixed(2)
  );
  const labels = Object.keys(dates);
  return (
    <div>
      <p>
        Dates <span className="pull-right text-muted">hours</span>
      </p>
      <Bar
        data={{
          datasets: [
            {
              data,
              backgroundColor: '#a3d4fa'
            }
          ],
          labels
        }}
        onElementsClick={(elems) => {
          if (elems && elems.length) {
            const index = elems[0]._index;
            if (onClick) {
              return onClick({ label: labels[index], data: data[index] });
            }
          }
        }}
        options={{
          scales: {
            yAxes: [
              {
                display: true,
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        }}
        legend={{ display: false }}
      />
    </div>
  );
};

export const TotalsGraph = ({ totals }) => {
  return (
    <div>
      <p>
        Estimated vs Actual <span className="pull-right text-muted">hours</span>
      </p>
      <Bar
        data={{
          datasets: [
            {
              data: [
                convert(totals.original_estimate, 'hours').toFixed(2),
                convert(totals.adjusted_estimate, 'hours').toFixed(2),
                convert(totals.work_time, 'hours').toFixed(2)
              ],
              backgroundColor: ['#a3d4fa', '#a3d4fa', '#2196f3']
            },
            {
              label: 'With breaks',
              data: [
                undefined,
                convert(totals.breaks_original_estimate, 'hours').toFixed(2),
                convert(totals.break_time, 'hours').toFixed(2)
              ],
              backgroundColor: ['#a3d4fa', '#ddd', '#ddd']
            }
          ],
          labels: ['Orig Estimate', 'Adj Estimate', 'Total Hours']
        }}
        options={{
          scales: {
            yAxes: [
              {
                stacked: true,
                display: true,
                ticks: {
                  beginAtZero: true
                }
              }
            ],
            xAxes: [
              {
                stacked: true
              }
            ]
          }
        }}
        legend={{ display: false }}
      />
    </div>
  );
};

export const PerStageTypeGraph = ({ perStageType }) => {
  return (
    <div>
      <p>
        Stage Types <span className="pull-right text-muted">hours</span>
      </p>

      <Bar
        data={{
          datasets: [
            {
              data: Object.values(perStageType).map((seconds) => {
                return convert(seconds, 'hours').toFixed(2);
              }),
              backgroundColor: '#a3d4fa'
            }
          ],
          labels: Object.keys(perStageType).map(
            (key) => key.charAt(0).toUpperCase() + key.slice(1)
          )
        }}
        options={{
          scales: {
            yAxes: [
              {
                display: true,
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        }}
        legend={{ display: false }}
      />
    </div>
  );
};

export const ScheduledTimeDiffGraph = ({ scheduledTimeDiff, onClick }) => {
  const data = Object.values(scheduledTimeDiff).map((seconds) =>
    convert(seconds, 'hours').toFixed(2)
  );
  const labels = Object.values(scheduledTimeDiff).map((seconds) => {
    const hours = convert(seconds, 'hours').toFixed(2);
    if (hours <= 0) {
      return `${hours * -1} hours early`;
    } else {
      return `${hours} hours late`;
    }
  });
  return (
    <div>
      <p>
        On Time <span className="pull-right text-muted">hours</span>
      </p>
      <Line
        data={{
          datasets: [
            {
              data,
              fill: false,
              backgroundColor: '#a3d4fa',
              borderColor: '#a3d4fa'
            }
          ],
          labels
        }}
        onElementsClick={(elems) => {
          if (elems && elems.length) {
            const index = elems[0]._index;
            if (onClick) {
              return onClick({
                label: Object.keys(scheduledTimeDiff)[index],
                data: data[index]
              });
            }
          }
        }}
        options={{
          scales: {
            yAxes: [
              {
                display: true,
                ticks: {
                  precision: 0,
                  beginAtZero: true
                }
              }
            ],
            xAxes: [
              {
                display: false
              }
            ]
          }
        }}
        legend={{ display: false }}
      />
    </div>
  );
};
